import { GATag } from '@domgen/dgx-fe-ga';
import {
  RegistrationGaCategory,
  RegistrationGaType,
  RegistrationGaVersion,
} from '@registration/util-models';

export const gaGlobalDataFactory = (): GATag => ({
  category: RegistrationGaCategory.Pages,
  type: RegistrationGaType.Standard,
  version: RegistrationGaVersion.Replatform,
});
